import inView from 'in-view';

const lazyImg = () => {
  if (document.querySelector('[data-src]')) {
    inView('[data-src]').on('enter', el => {
      el.setAttribute('src', el.getAttribute('data-src'));
    });
  }
};
export default lazyImg;



// WEBPACK FOOTER //
// ./src/scripts/modules/lazy-img.js